import React from 'react';
import styled from 'App/styled';
import CheckBox from '../Shared/CheckBox';
import ArrowIcon from 'components/Icons/Arrow';
import CrossIcon from 'components/Icons/CircleCross';
import { CategoryTreeProps } from 'types/filter';
import CategoryTree from './View';


const List = styled.li`
  margin-left: 14px;
`;

const ListBar = styled.div`
  width: 100%;
  padding: 14px 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: #${props => props.theme.colors.textPrimary};
  .filter-name {
    ${({ theme }) => theme.typography.bodyMedium};
  }
  &.active {
    border-bottom: 1px solid #ebebeb;
  }
  .arrow-icon,
  .cross-icon {
    fill: #5c6874;
    cursor: pointer;
    line-height: 22px;
    width: 20px;
  }
  .highlight {
    color: ${props => props.theme.brandPrimary};
    font-weight: 600;
  }
  .side-count {
    display: flex;
    align-items: center;
  }
  .count {
    margin-right: 10px;
    color: gray;
    &.highlight {
      color: ${props => props.theme.brandPrimary};
    }
  }
`;

const Bar = (props: CategoryTreeProps) => {
  let isSelected = false;
  let highlightClass = '';
  const { selectedFilterData, filterValue, navigateFilters, handleFilterChange } = props;
  const { id, name, selectedCount = 0 } = filterValue || {};
  const filterChild = filterValue?.children;
  const showChildren = filterChild && filterChild?.length > 0;
  const liClass = showChildren ? 'active' : '';
  if (!showChildren && selectedFilterData) {
    isSelected = selectedFilterData?.some((filterItem: any) => filterItem?.id == filterValue?.id);
  }
  if (
    filterChild &&
    filterChild?.[0] &&
    ((!filterChild[0]?.children) || (filterChild[0]?.children?.length === 0))
  ) {
    highlightClass = 'highlight';
  }
  const handleNavigation = e => {
    navigateFilters(filterValue, showChildren);
    e.stopPropagation();
  };
  return (
    <List key={`parent-${id}-${name}`}>
      {filterChild ? (
        <>
          <ListBar key={`${id}-${name}`} className={liClass} onClick={handleNavigation}>
            <span className={`filter-name ${highlightClass}`}>{name}</span>
            <span className="side-count">
              {selectedCount > 0 && (
                <span className={`count ${highlightClass}`}>{selectedCount}</span>
              )}
              {!showChildren && <ArrowIcon />}
              {showChildren && <CrossIcon />}
            </span>
          </ListBar>
          {showChildren && (
            <CategoryTree
              selectedFilterData={selectedFilterData}
              list={filterChild}
              navigateFilters={navigateFilters}
              handleFilterChange={handleFilterChange}
            />
          )}
        </>
      ) : (
        <CheckBox
          key={id}
          data={filterValue}
          isSelected={isSelected}
          handleFilterChange={handleFilterChange}
        />
      )}
    </List>
  );
};

export default Bar;
